import type {Database} from "../types/database.types";
import type {DbClient} from "./activity-types";

export type FieldCheckStatus =
  | "unverified"
  | "trusted_import"
  | "needs_review"
  | "confirmed"
  | "corrected"
  | "wrong"
  | "withdrawn";

export type FieldCheckStatusRow = Database["public"]["Functions"]["get_business_card_field_check_status"]["Returns"][number];

/** 状態RPCの500件上限に合わせて取得。不可視の名刺はMapに含まれない。 */
export async function getBusinessCardFieldCheckStatus(
  client: DbClient,
  ids: readonly string[],
): Promise<Map<string, FieldCheckStatusRow>> {
  const uniqueIds = [...new Set(ids)];
  const result = new Map<string, FieldCheckStatusRow>();
  for (let offset = 0; offset < uniqueIds.length; offset += 500) {
    const {data, error} = await client.rpc("get_business_card_field_check_status", {
      p_card_ids: uniqueIds.slice(offset, offset + 500),
    });
    if (error) throw error;
    for (const row of data ?? []) result.set(row.business_card_id, row);
  }
  return result;
}
